import React from 'react'
  import { MDXTag } from '@mdx-js/tag'


  const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = null;
  }

  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" components={components}><MDXTag name="h1" components={components}>{`Button`}</MDXTag>
      <MDXTag name="p" components={components}>{`Basic styled button. Extends `}<MDXTag name="a" components={components} parentName="p" props={{
          "href": "/Box"
        }}>{`Box`}</MDXTag>{`.`}</MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-.jsx"
        }}>{`<Button bg='magenta'>Button</Button>
`}</MDXTag></MDXTag>
      <MDXTag name="h2" components={components}>{`Props`}</MDXTag>
      <MDXTag name="p" components={components}>{`In addition to the base `}<MDXTag name="a" components={components} parentName="p" props={{
          "href": "/Box"
        }}>{`Box`}</MDXTag>{` props, Button includes the following style props.`}</MDXTag>
      <MDXTag name="ul" components={components}>
        <MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`fontWeight`}</MDXTag></MDXTag>
        <MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`border`}</MDXTag></MDXTag>
        <MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`borderColor`}</MDXTag></MDXTag>
        <MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`borderRadius`}</MDXTag></MDXTag>
        <MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`variant`}</MDXTag>{`: button style `}<MDXTag name="a" components={components} parentName="li" props={{
            "href": "/theming/#button--card-variants"
          }}>{`variant`}</MDXTag></MDXTag>
      </MDXTag>
           </MDXTag>;
  }

}
MDXContent.isMDXComponent = true;
export const _frontmatter = {};
      